import simg from '../images/service-single/3.webp'
import simg2 from '../images/service-single/4.webp'
import simg3 from '../images/service-single/5.webp'
import simg4 from '../images/service-single/6.webp'
import simg5 from '../images/service-single/7.webp'
import simg6 from '../images/service-single/8.webp'
// import simg7 from '../images/service-single/7.jpg'
// import simg8 from '../images/service-single/8.jpg'
// import simg9 from '../images/service-single/9.jpg'
// import simg10 from '../images/service-single/10.jpg'
import simg11 from '../images/service-single/Vente&Achat.webp'
import simg12 from '../images/service-single/30.webp'
import simg13 from '../images/service-single/Construction-Riad.webp'

import sSingleimg1 from '../images/service-single/s1.jpg'
import sSingleimg2 from '../images/service-single/s2.jpg'


import ins1 from '../images/instragram/7.jpg'
import ins2 from '../images/instragram/8.jpg'
import ins3 from '../images/instragram/9.jpg'
import ins4 from '../images/instragram/10.jpg'
import ins5 from '../images/instragram/11.jpg'
import ins6 from '../images/instragram/12.jpg'


const Services = [
    {
        Id: '1',
        sImg:simg,
        sTitle: 'Planification Parfaite',
        description:'La réussite d’un projet repose sur une planification précise et méthodique. Avec notre expertise, nous anticipons chaque étape de votre projet de construction ou de rénovation pour garantir une exécution fluide et sans imprévus. De l’étude initiale à la livraison finale, nous assurons un suivi rigoureux pour respecter vos exigences, votre budget et les délais convenus.',
        des2:'Planification détaillée pour une réalisation fluide et respect des délais.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-planning',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins1,
        section1:{ 
            title      :"Nos Compétences",
            description:"Notre équipe met en place une organisation optimale pour une gestion efficace de votre projet :",
            details    :[
                "Analyse approfondie de votre projet et de sa faisabilité",
                "Élaboration d’un planning détaillé avec gestion des délais",
                "Coordination des différents corps de métier pour une exécution fluide",
                "Optimisation des ressources et du budget",
                "Anticipation des contraintes techniques et administratives"
            ]
        },
        section2:{ 
            title:"Notre Approche",
            description:"Nous adoptons une approche structurée et personnalisée afin de garantir le bon déroulement de votre projet. Chaque plan est conçu sur mesure pour répondre à vos besoins spécifiques, en tenant compte des normes de qualité et des meilleures pratiques du secteur.",
        },
        section3:{ 
            title:"Notre Processus de Travail",
            details:[
                "Étude du projet, définition des objectifs et des contraintes.",
                "Planification détaillée des travaux et des ressources.",
                "Supervision des étapes clés pour assurer une progression sans faille.",
                "Vérification des détails et ajustements avant la livraison finale."
            ]
        }
    },
    {
        Id: '2',
        sImg:simg2,
        sTitle: 'Design Professionnel',
        description:'Confiez la création de votre riad à des experts du design professionnel. Nous vous accompagnons dans la conception de chaque espace en combinant expertise technique, esthétique et fonctionnalité. Du choix des matériaux à la disposition des éléments, chaque projet est personnalisé pour répondre à vos attentes, tout en mettant en valeur les caractéristiques architecturales uniques de votre riad.',
        des2:'Design professionnel sur mesure pour un riad harmonieux et fonctionnel.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-blueprint',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins2,
        
        section1:{ title:"Nos Compétences",
            description:"Nous mettons notre savoir-faire au service de votre projet pour un design sur mesure :",
            details:[
                "Conception d’espaces optimisés et esthétiques",
                "Sélection des matériaux et des couleurs en harmonie avec votre style",
                "Intégration des dernières tendances en design et innovation",
                "Aménagement intérieur et extérieur pour un rendu cohérent",
                "Personnalisation selon vos goûts et vos besoins"
            ]
        },
        section2:{ title:"Notre Approche",
            description:"Chaque projet est unique. Nous analysons votre espace et vos attentes pour proposer un design qui reflète votre identité. Nous associons créativité et expertise technique pour concevoir des environnements fonctionnels et inspirants.",
        },
        section3:{ title:"Notre Processus de Travail",
           
            details:[
                "Analyse de vos besoins et création d’un concept adapté.",
                "Élaboration de plans et de visuels 3D pour une vision précise.",
                "Choix des matériaux, couleurs et éléments décoratifs.",
                "Supervision de la réalisation pour garantir un rendu impeccable.",
            ]
        }
    },
    {
        Id: '3',
        sImg:simg3,
        sTitle: 'Intérieur d’Exception',
        description:" Offrez à votre riad un intérieur d'exception alliant luxe, confort et authenticité. Nous créons des espaces raffinés, où chaque détail est pensé pour harmoniser tradition et modernité. Grâce à notre expertise, nous sélectionnons les meilleurs matériaux et accessoires pour concevoir un environnement chic, fonctionnel et intemporel, qui reflète votre personnalité et sublime l’âme de votre riad.",
        des2:'Un intérieur d’exception pour un riad chic, raffiné et sur mesure.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-double-bed',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins3,
        
        section1:{ title:"Nos Compétences",
            description:"Notre expertise vous garantit un intérieur à la hauteur de vos exigences :",
            details:[
                "Agencement sur mesure pour une optimisation parfaite des espaces",
                "Sélection de matériaux prestigieux et durables",
                " Intégration de luminaires et éléments décoratifs sophistiqués",
                " Création d’une ambiance harmonieuse entre tradition et modernité",
                " Mobilier et accessoires design pour une touche unique"
            ]
        },
        section2:{ title:"Notre Approche",
            description:"Un intérieur d’exception est le fruit d’une conception minutieuse et d’un savoir-faire artisanal. Nous étudions votre espace et vos envies pour créer une atmosphère exclusive, à la fois chaleureuse et fonctionnelle.",
        },
        section3:{ title:"Notre Processus de Travail",
           
            details:[
                "Étude de vos besoins et création d’un concept unique.",
                "Choix des matériaux, couleurs et éléments décoratifs adaptés.",
                "Élaboration de plans et intégration d’éléments sur mesure.",
                "Finitions haut de gamme et mise en valeur des détails.",
            ]
        }
    },
    {
        Id: '4',
        sImg:simg4,
        sTitle: 'Mobilier Sur-Mesure',
        description:'Transformez votre riad avec du mobilier sur mesure, conçu pour épouser parfaitement l’architecture et le style de votre intérieur. Nous créons des pièces uniques en utilisant des matériaux de qualité et un savoir-faire artisanal pour garantir confort, esthétisme et durabilité. Chaque meuble est conçu pour optimiser l’espace, en alliant élégance et fonctionnalité, tout en ajoutant une touche personnelle à votre environnement.',
        des2:'Mobilier sur mesure pour des espaces uniques, alliant confort, style et tradition.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-armchair',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins4,
        section1:{ title:"Nos Compétences",
            description:"Nous mettons notre expertise au service de votre projet pour un mobilier d’exception :",
            details:[
                "Création de meubles adaptés à votre espace et à vos goûts.",
                "Sélection de bois nobles, métaux raffinés et tissus de qualité.",
                "Collaboration avec des ébénistes et artisans spécialisés.",
                "Solutions intelligentes pour un agencement fonctionnel et élégant.",
                "Détails soignés pour un rendu harmonieux et durable."
            ]
        },
        section2:{ title:"Notre Approche",
            description:"Chaque meuble doit être une œuvre unique, conçue pour s’intégrer harmonieusement à votre intérieur. Nous prenons en compte vos besoins spécifiques, votre style et les contraintes de votre espace pour vous proposer des créations à la fois esthétiques et pratiques.",
        },
        section3:{ title:"Notre Processus de Travail",
           
            details:[
                "Analyse de votre intérieur et création d’un design sur mesure.",
                "Sélection des textures, couleurs et finitions adaptées.",
                "Réalisation par des experts du mobilier haut de gamme.",
                "Intégration parfaite dans votre espace pour un rendu optimal.",
            ]
        }
    },
    {
        Id: '5',
        sImg:simg5,
        sTitle: 'Décoration Complète',
        description:'Offrez à votre riad une décoration complète qui reflète votre style tout en respectant l’authenticité de l’architecture traditionnelle. Nous sélectionnons avec soin les meubles, accessoires et éléments décoratifs pour créer une ambiance chaleureuse et élégante. Chaque espace est métamorphosé grâce à des choix de décoration sur mesure, alliant confort moderne et esthétique marocaine, pour un résultat unique et raffiné.',
        des2:'Décoration personnalisée pour un riad chic, fonctionnel et empreint de caractère.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-furniture',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins5,
        section1:{ title:"Nos Compétences",
            description:"Nous vous accompagnons dans chaque détail pour une décoration sur-mesure et équilibrée :",
            details:[
                "Création d’un univers cohérent et personnalisé.",
                "Association harmonieuse des teintes, textures et matériaux.",
                "Choix de pièces adaptées à l’espace et au confort recherché.",
                "Optimisation de la lumière pour une ambiance chaleureuse.",
                "Tapis, rideaux, œuvres d’art et objets décoratifs sélectionnés avec soin."
            ]
        },
        section2:{ title:"Notre Approche",
            description:"Chaque projet de décoration est une œuvre d’art où chaque élément est pensé pour créer une harmonie visuelle et sensorielle. Nous prenons en compte vos goûts, l’architecture du lieu et les tendances actuelles pour concevoir un espace unique et raffiné.",
        },
        section3:{ title:"Notre Processus de Travail",
           
            details:[
                "Évaluation des volumes, de la lumière et du style existant",
                "Création de moodboards et choix des éléments décoratifs.",
                " Mise en place du mobilier, des accessoires et des finitions.",
                "Derniers détails pour un rendu parfait et harmonieux.",
            ]
        }
    },
    {
        Id: '6',
        sImg:simg6,
        sTitle: 'Aménagement Extérieur',
        description:'Transformez vos espaces extérieurs en véritables havres de paix, où tradition et modernité se rencontrent. Nous créons des jardins, terrasses et patios adaptés à vos besoins, en utilisant des matériaux authentiques et durables. Chaque projet est conçu pour optimiser l’espace disponible tout en respectant l’esthétique de votre riad et l’environnement extérieur, afin de créer un lieu de détente et de convivialité.',
        des2:'Aménagement extérieur harmonieux pour sublimer vos espaces et créer des ambiances uniques.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-interior-design',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
        section1:{ title:"Nos Compétences",
            description:"Nous vous accompagnons dans chaque détail pour un extérieur unique et optimisé :",
            details:[
                "Aménagement d’espaces de détente conviviaux et élégants.",
                "Sélection et agencement de végétaux pour une atmosphère naturelle et apaisante.",
                "Intégration d’éléments d’eau pour une touche de raffinement et de fraîcheur.",
                "Mise en valeur de votre espace avec un éclairage adapté et esthétique.",
                "Sélection de pièces adaptées aux conditions climatiques et au design souhaité."
            ]
        },
        section2:{ title:"Notre Approche",
            description:"Nous concevons chaque projet en harmonie avec son environnement, en privilégiant des matériaux durables et des solutions adaptées au climat. Notre objectif est de créer des espaces extérieurs accueillants et fonctionnels, où il fait bon vivre toute l’année.",
        },
        section3:{ title:"Notre Processus de Travail",
           
            details:[
                "Analyse de l’espace et création d’un plan d’aménagement sur-mesure.",
                "Choix de solutions adaptées à l’environnement et aux préférences du client.",
                "Installation des éléments paysagers, du mobilier et des équipements.",
                "Derniers réglages pour un rendu esthétique et durable.",
            ]
        }
    },
    {/*
        Id: '7',
        sImg:simg7,
        sTitle: 'Interior Design',
        description:'Lacus, etiam sed est eu tempus need Temer diam congue laoret cursus nam nunc fam interdum Viverra.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-interior-design',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,*/
    },
    {   /*
        Id: '8',
        sImg:simg8,
        sTitle: 'Room Decoration',
        description:'Lacus, etiam sed est eu tempus need Temer diam congue laoret cursus nam nunc fam interdum Viverra.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,*/
    },
    {/*
        Id: '9',
        sImg:simg9,
        sTitle: 'Planning',
        description:'Lacus, etiam sed est eu tempus need Temer diam congue laoret cursus nam nunc fam interdum Viverra.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6, */
    },
    {/*
        Id: '10',
        sImg:simg10,
        sTitle: 'Lighting',
        description:'Lacus, etiam sed est eu tempus need Temer diam congue laoret cursus nam nunc fam interdum Viverra.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
    */},
    {
        Id: '11',
        sImg:simg11,
        sTitle: 'Vente & Achat des Riads',
        description:'Trouvez le riad de vos rêves ou vendez votre bien dans les meilleures conditions grâce à notre expertise. Nous vous accompagnons à chaque étape du processus, en mettant à votre disposition notre connaissance approfondie du marché immobilier et notre réseau d’acheteurs et de vendeurs.',
        des2:'Achetez ou vendez un riad en toute confiance grâce à notre expertise immobilière.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
        section1:{ title:"Nos Compétences",
            description:"Nous vous garantissons une transaction sécurisée et avantageuse grâce à nos services spécialisés :",
            details:[
                "Analyse du marché pour une estimation juste et compétitive.",
                "Sélection de biens correspondant à vos critères et à votre budget.",
                "Gestion des démarches juridiques et notariales pour une transaction en toute sérénité.",
                "Stratégies de présentation et de marketing pour optimiser la vente.",
                "Propositions d’amélioration pour maximiser la rentabilité de votre investissement."
            ]
        },
        section2:{ title:"Notre Approche",
            description:"Que vous souhaitiez acheter ou vendre un riad, nous adoptons une approche personnalisée basée sur vos besoins et vos attentes. Grâce à notre connaissance du marché local, nous vous aidons à prendre des décisions éclairées pour une transaction fluide et réussie.",
        },
        section3:{ title:"Notre Processus de Travail",
           
            details:[
                "Évaluation du bien et définition de la stratégie de vente ou d’achat.",
                "Proposition de riads correspondant à vos exigences ou promotion ciblée de votre bien.",
                "Accompagnement dans les discussions et gestion des démarches légales.",
                "Signature des documents et remise des clés en toute transparence.",
            ]
        }
    },
    {
        Id: '12',
        sImg:simg12,
        sTitle: 'Construction de Riads Neufs',
        description:'Nous concevons et réalisons des riads uniques alliant tradition et modernité. De la conception des plans à la livraison clé en main, nous mettons notre savoir-faire au service de votre projet pour créer un espace authentique, élégant et fonctionnel, respectant les matériaux et techniques artisanales marocaines.',
        des2:'Création de riads neufs alliant authenticité, confort et design moderne.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
        section1:{ title:"Nos Compétences",
            description:"Notre expertise en construction vous garantit un riad d’exception, conçu avec des matériaux de qualité et un savoir-faire artisanal :",
            details:[
                "Conception architecturale sur mesure.",
                "Respect du patrimoine et des techniques traditionnelles.",
                "Optimisation de l’espace et du confort.",
                "Construction durable et éco-responsable.",
                "Aménagement intérieur et extérieur."
            ]
        },
        section2:{ title:"Notre Approche",
            description:"Chaque riad est unique et doit refléter l’âme de ses propriétaires. Nous vous accompagnons dans toutes les étapes du projet, en combinant expertise architecturale et maîtrise des techniques traditionnelles pour créer un espace à la fois raffiné et fonctionnel.",
        },
        section3:{ title:"Notre Processus de Travail",
           
            details:[
                "Étude et planification.",
                "Choix des matériaux et artisans.",
                "Construction et suivi des travaux.",
                "Finitions et remise des clés.",
            ]
        }
    },
    {
        Id: '13',
        sImg:simg13,
        sTitle: 'Rénovation de Riads',
        description:'Redonnez une nouvelle vie à votre riad avec notre expertise en rénovation. Nous allions tradition et modernité pour préserver l’authenticité architecturale tout en optimisant le confort et la fonctionnalité de votre espace. Que ce soit une restauration complète ou des améliorations spécifiques, nous vous accompagnons à chaque étape pour créer un lieu unique et raffiné.',
        des2:'Rénovation sur mesure pour un riad authentique, élégant et fonctionnel.',
        // des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins6,
        section1:{ title:"Nos Compétences",
            description:"Grâce à notre savoir-faire, nous vous proposons des prestations sur mesure pour sublimer votre riad :",
            details:[
                "Restauration des éléments traditionnels (zellige, bois sculpté, tadelakt…)",
                "Réaménagement des espaces intérieurs et extérieurs.",
                "Optimisation de l’isolation et des installations modernes.",
                "Valorisation du patrimoine tout en intégrant des touches contemporaines.",
                "Utilisation de matériaux authentiques et durables."
            ]
        },
        section2:{ title:"Notre Approche",
            description:"Chaque riad a une âme et une histoire. Notre approche repose sur une étude approfondie de votre bien pour proposer une rénovation qui respecte son caractère unique. Nous collaborons avec des artisans spécialisés pour garantir une finition haut de gamme et une intégration harmonieuse des éléments architecturaux.",
        },
        section3:{ title:"Notre Processus de Travail",
           
            details:[
                "Évaluation de l’état du riad et définition des besoins..",
                "Élaboration des plans et choix des matériaux.",
                "Restauration et modernisation selon les standards de qualité.",
                "Mise en valeur des détails pour un rendu esthétique et fonctionnel.",
            ]
        }
    },
]
export default Services;